
export class EditEmployeePasswordRequest {
  constructor(
    readonly password: string,
    readonly confirmPassword: string
  ) { }
}
